import { DateTime } from 'luxon';
import { EventTimeSpan } from '../types/Event';
import { useMemo } from 'react';

export function useDateRange(type: EventTimeSpan): [string | null, string | null] {
  const now = useMemo(() => DateTime.now(), []);

  let dates: (DateTime<true> | null)[];
  switch (type) {
    case EventTimeSpan.TODAY:
      dates = [now, now];
      break;

    case EventTimeSpan.TOMORROW:
      dates = [now.plus({ days: 1 }), now.plus({ days: 1 })];
      break;

    case EventTimeSpan.WEEK:
      dates = [now.startOf('week'), now.endOf('week')];
      break;

    case EventTimeSpan.UPCOMING:
      dates = [now, null];
      break;

    default:
      throw new Error(`Unsupported date range type: ${type}`);
  }

  const [start, end] = dates;
  return [start?.set({ hour: 0, minute: 0, second: 0 })?.toISO() ?? null, end?.set({ hour: 23, minute: 59, second: 59 })?.toISO() ?? null];
}
